import { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';

const useDebouncedLoading = (
    isLoading: boolean,
    minDurationMs = 500
): boolean => {
    const [showLoading, setShowLoading] = useState(false);
    const [debouncedIsLoading] = useDebounce(
        isLoading,
        isLoading ? 0 : minDurationMs
    );

    useEffect(
        () => setShowLoading(debouncedIsLoading || isLoading),
        [debouncedIsLoading, isLoading]
    );

    return showLoading;
};

export default useDebouncedLoading;
